import React from 'react';
import { Button } from 'src/components/ui/button';
import { useNotification } from 'src/hooks/useNotification';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { ghcolors } from 'react-syntax-highlighter/dist/cjs/styles/prism';
import { SETUP_GUIDE_URL } from 'src/constants/urls';

export const EditZohoSalesIQAutoSetupSettings = ({ code = '' }) => {
  const notification = useNotification();
  const copyToClipboard = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    await navigator.clipboard.writeText(code);

    notification.success('Copied to clipboard');
  };

  return (
    <div className={'w-full flex flex-col gap-2.5 p-5 bg-light rounded-sm-5'}>
      <div className={'flex flex-row justify-between items-center'}>
        <p className={'text-ebony font-semibold text-sm'}>Instruction:</p>
      </div>
      <ul className={'list-decimal px-3'}>
        <li>
          <p className={'text-sm text-ebony_opacity_70 font-medium'}>
            Before you begin, copy and save the code snippet below — you’ll need it when creating a
            Plug in Zoho SalesIQ.
          </p>
          <p className={'py-1.5'}>
            <span className="text-xs leading-5 font-medium text-ebony_opacity_50 select-none">
              Plug Script:
            </span>
          </p>
          <div className={'overflow-hidden bg-white'}>
            <SyntaxHighlighter
              language="javascript" // closest syntax to Deluge
              style={ghcolors}
              customStyle={{
                borderRadius: '3px',
                padding: '16px',
                fontSize: '14px',
                width: '100%',
                height: '10rem',
                overflow: 'auto',
                marginBottom: '0',
                marginTop: '0',
              }}
            >
              {code}
            </SyntaxHighlighter>
          </div>
          <Button className={'px-8 mt-2.5 mb-4'} onClick={copyToClipboard} disabled={!code}>
            Copy
          </Button>
        </li>
        <li>
          <p className={'text-sm text-ebony_opacity_70'}>
            Once you do, follow our{' '}
            <a
              target={'_blank'}
              className={'text-ebony italic font-semibold hover:underline'}
              href={SETUP_GUIDE_URL.ZOHO_SALES_IQ}
              rel="noopener noreferrer"
            >
              Zoho SalesIQ Setup Guid
            </a>{' '}
            to complete the integration.
          </p>
        </li>
      </ul>
    </div>
  );
};
